module.exports = __webpack_public_path__ + "static/media/qrcode2.ea98bf20.png";